import React, { Component } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Divider,
  Button,
  CardActions,
  CardHeader,
  CardMedia,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";
import ResetDate from "../images/resetdate.png";

import ArticleIcon from "@mui/icons-material/Article";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReportIcon from "@mui/icons-material/Report";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AddIcon from "@mui/icons-material/Add"; // Plus icon
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DescriptionIcon from "@mui/icons-material/Description";
import BookIcon from "@mui/icons-material/Book";
import { useNavigate } from "react-router-dom";
import income from "../images/income.png";
import expenses from "../images/expenses .png";
import sale from "../images/sale.png";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Aos from "aos";
import "./Dashboard2.css";
import "aos/dist/aos.css";

import { useEffect } from "react";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCReduxData from "../HOC/HOCReduxData";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";

import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

// ES6
// var ReactCSSTransitionGroup = require('react-transition-group');
import Date from "./date";
import moment from "moment";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_DMY,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";
class Dashboard2 extends Component {
  componentDidMount() {
    console.log("Dialog mounted"); // Ensure it gets mounted
  }

  constructor(props) {
    super(props);

    //   useEffect(() => {
    //     Aos.init({
    //       duration: 1000,
    //       easing: "ease-in-out",
    //       once: true,
    //     });
    //   }, []);

    this.state = {
      dataLoadStatus: true,
      openDialog: false,

      date: [
        { name: "Today" },
        { name: "This Month" },
        {
          name: "From Date - To Date",
        },
      ],
      services: [
        {
          status: "Active",
          plan: "SSD Shared Hosting - SSD Standard Plan",
          domain: "apcmkalavad.in",
        },
        {
          status: "Active",
          plan: "SSD Shared Hosting - SSD Standard Plan",
          domain: "wayonmarketing.com",
        },
        {
          status: "Active",
          plan: "Cloud Hosting - USA - Business Cloud - USA",
          domain: "ravitechworld.com",
        },
        {
          status: "Active",
          plan: "Cloud Hosting - USA - Business Cloud - USA",
          domain: "sahakarexports.com",
        },
      ],
      data: [
        {
          id: 1,
          tcolor: "#05699d",
          color: "#d6effc",

          title: "Total Sales",
          amount: " ₹ 3,766",
          subtitle: "Total Sales Today: 250",
          //   color: "#e3f2fd",
          txtdate: "Today",
          icon: (
            <CardMedia
              component="img"
              alt="green iguana"
              sx={{ width: 45 }}
              image={sale}
            />
          ),
          route: "/SalesList",
          route1: "/Salesentry",
          t: "Sales List",
          t1: "Sales Entry",
          Today: " ₹ 3,766",
          ThisMonth: " ₹ 12,342",
          FromDateToDate: " ₹ 8,145",

          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          id: 2,
          tcolor: "#05699d",
          color: "#d6effc",

          txtdate: "Today",
          title: "Total Purchase",
          amount: " ₹ 652",
          subtitle: "Total Purchase Today: 40",
          //   color: "#fffde7",

          icon: <ShoppingCartIcon sx={{ fontSize: 50, color: "black" }} />,
          route: "/PurchaseList",
          route1: "/PurchaseEntry",
          t: "Purchase List",
          t1: "Purchase Entry",
          Today: " ₹ 652",
          ThisMonth: " ₹ 2,124",
          FromDateToDate: " ₹ 1,780",

          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          id: 3,
          tcolor: "#388e3c",
          color: "#e8f5e9",

          txtdate: "Today",
          title: "Total Receipt ",
          amount: "  ₹ 21,156",
          subtitle: "Total Recepit Today: 310",
          //   color: "#e8f5e9 ",
          route: "/ReceiptList",
          route1: "/ReceiptEntry",
          t: "Receipt List",
          t1: "Receipt Entry",
          icon: (
            <CardMedia
              component="img"
              alt="green iguana"
              sx={{ width: 50 }}
              image={income}
            />
          ),
          Today: " ₹ 21,156",
          ThisMonth: " ₹ 45,876",
          FromDateToDate: " ₹ 39,213",

          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),
        },
        {
          tcolor: "#388e3c",
          color: "#e8f5e9",

          dtpFromDate: moment().subtract(30, "days").format("DD-MM-YYYY"),
          dtpToDate: moment().format("DD-MM-YYYY"),

          id: 4,
          txtdate: "Today",
          Today: " ₹ 38",
          ThisMonth: " ₹ 1,024",
          FromDateToDate: " ₹ 852",
          title: "Total Payment",
          amount: "38",
          subtitle: "Total Payment Today: 2",
          //   color: "#ffebee",

          route: "/PaymentList",
          route1: "/PaymentEntry",
          t: "Payment List",
          t1: "Payment Entry",
          icon: (
            <CardMedia
              component="img"
              alt="green iguana"
              sx={{ width: 50 }}
              image={expenses}
            />
          ),
        },
      ],
      reports: [
        {
          title: "Customer Book",
          icon: <BookIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/BookReport/Customer",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
        {
          title: "Supplier Book",
          icon: <PeopleAltIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/BookReport/Supplier",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
        {
          title: "Day Book",
          icon: <AssignmentIcon sx={{ fontSize: 40, color: "black" }} />,
          rout: "/DayBookReport",
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },

        {
          title: "GST Report",
          icon: <DescriptionIcon sx={{ fontSize: 40, color: "black" }} />,
          color: "#ffffff",
          hcolor: "#d1e5f0",
        },
      ],
    };
  }

  handleNavigate = (route) => {
    this.props.navigate(route); // Use navigate passed as prop
  };
  calculateSubtitle = (item) => {
    const currentDate = item.txtdate || this.state.txtdate;

    const getSubtitleContent = () => {
      switch (currentDate) {
        case "Today":
          return `Today: ${item.Today}`;
        case "This Month":
          return `This Month: ${item.ThisMonth}`;
        case "From Date - To Date":
          const fromDate = item.dtpFromDate
            ? ` ${item.dtpFromDate}`
            : "From Date";
          const toDate = item.dtpToDate ? `${item.dtpToDate}` : "To Date";
          return `${fromDate} To ${toDate}: ${item.FromDateToDate}`;
        default:
          return "";
      }
    };

    return currentDate === "From Date - To Date" ? (
      <span
        style={{
          cursor: "pointer",
        }}
        onClick={() => this.openDialog(item)}
      >
        {getSubtitleContent()}
      </span>
    ) : (
      getSubtitleContent()
    );
  };

  setFromToDate = (id, fromDate, toDate) => {
    this.setState((prevState) => ({
      data: prevState.data.map((item) =>
        item.id === id
          ? { ...item, dtpFromDate: fromDate, dtpToDate: toDate }
          : item
      ),
    }));
  };

  // setfrom_todate = (reset = false) => {
  //   setlocalstoragedate(
  //     "Dashboard2",
  //     this.state.formData.dtpFromDate,
  //     this.state.formData.dtpToDate,
  //     reset
  //   );
  //   if (reset) {
  //     window.location.reload();
  //     this.onFormLoad();
  //   }
  // };

  // onFormLoad = () => {
  //   const { fromdate, todate } = getlocalstoragedate("Dashboard2");
  //   let dtpFromDate = fromdate,
  //     dtpToDate = todate;
  //   // let dtpFromDate = get_30DaysBack_FromCurrentDate(),
  //   //   dtpToDate = get_YMD_from_SYS(new Date());
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //         dtpFromDate,
  //         dtpToDate,
  //       },
  //     },
  //     () => {
  //       this.getInfo();
  //     }
  //   );
  // };
  // validateDate = () => {
  //   let result = false;
  //   if (this.state.formData.dtpFromDate.length <= 0) {
  //     this.props.toastErrorMsg("Enter Date", "dtpFromDate");
  //   } else if (
  //     validatedate_min_max(
  //       this.state.formData.dtpFromDate,
  //       "dtpFromDate",
  //       this.props.toastErrorMsg
  //     ) == false
  //   ) {
  //     return result;
  //   } else if (this.state.formData.dtpToDate.length <= 0) {
  //     this.props.toastErrorMsg("Enter Date", "dtpToDate");
  //   } else if (
  //     validatedate_min_max(
  //       this.state.formData.dtpToDate,
  //       "dtpToDate",
  //       this.props.toastErrorMsg
  //     ) == false
  //   ) {
  //     return result;
  //   } else {
  //     result = true;
  //   }
  //   return result;
  // };

  // getInfo = () => {
  //   if (this.validateDate()) {
  //     let dataLoadStatus = false;
  //     this.setState({ dataLoadStatus }, () => {
  //       const reqData = {
  //         Op: "PurchaseList",
  //         bint_acyear: localStorage.getItem("ACY"),
  //         bint_acid: localStorage.getItem("acid"),
  //         dat_fromdate: this.state.formData.dtpFromDate,
  //         dat_todate: this.state.formData.dtpToDate,
  //       };
  //     });
  //   }
  // };
  handleOnChange = (e, id) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      data: prevState.data.map((item) =>
        item.id === id ? { ...item, txtdate: value } : item
      ),
    }));

    // txtdate: newDate,
  };
  handleDateChange = (name, value, id) => {
    const formattedDate = moment(value).format("DD-MM-YYYY");

    this.setState((prevState) => ({
      data: prevState.data.map((item) =>
        item.id === id ? { ...item, [name]: formattedDate } : item
      ),
    }));
  };

  openDialog = (item) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <Date
              handleDateChange={this.handleDateChange}
              id={item.id}
              // dtpFromDate={item.dtpFromDate}
              // dtpToDate={item.dtpToDate}
            />
          }
          defaultOpenDialog={true}
        />
      );
      this.setState({ ARD });
    });
  };

  render() {
    const { date } = this.state;
    return (
      <Grid container spacing={2} padding={2}>
        {/* Metrics Section */}
        <Grid item xs={8}>
          <Grid container justifyContent="flex-start" spacing={2}>
            {this.state.data.map((item, index) => (
              <Grid item key={item.id}>
                <Card
                  key={item.id}
                  sx={{
                    backgroundColor: item.color,
                    color: "black",
                    height: "230px",
                    width: "380px",
                    position: "relative",
                  }}
                >
                  <CardHeader
                    avatar={
                      <Typography
                        variant="h5"
                        style={{
                          color: item.tcolor,
                          fontWeight: "600",
                          letterSpacing: 2,
                        }}
                      >
                        {item.title}
                      </Typography>
                    }
                    action={
                      <CardActions>
                        <IconButton
                          sx={{
                            cursor: "pointer",
                            transition: "transform 0.3s ease-in-out",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={() => this.handleNavigate(item.route)}
                          title={item.t}
                        >
                          <ArticleIcon sx={{ color: item.tcolor }} />
                        </IconButton>
                        <IconButton
                          sx={{
                            cursor: "pointer",
                            transition: "transform 0.3s ease-in-out",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                          onClick={() => this.handleNavigate(item.route1)}
                          title={item.t1}
                        >
                          <AddCircleIcon sx={{ color: item.tcolor }} />
                        </IconButton>
                      </CardActions>
                    }
                  />
                  <CardContent>
                    <Grid
                      container
                      direction={"row"}
                      spacing={3}
                      textAlign={"center"}
                    >
                      <Grid item>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "black" }}
                        >
                          {item.amount}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "white",
                        alignItems: "center",
                        // justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <Divider
                        orientation="vertical"
                        sx={{
                          height: "100%", // Set height relative to parent
                          width: "6px",
                          backgroundColor: item.tcolor,
                          minHeight: 100,
                          // alignSelf: "center",
                        }}
                      />
                      <Box
                        sx={{
                          flexDirection: "column",
                          margin: "auto",
                          marginLeft: "15px",
                        }}
                      >
                        <Grid
                          container
                          direction="column"
                          alignContent={"flex-end"}
                        >
                          <Grid item>
                            <CtCmb
                              // id="date"
                              id={`date-${item.id}`}
                              label=""
                              items={date}
                              value={item.txtdate}
                              handleOnChange={(e) => {
                                console.log("Handling change for item:", item); // Debugging
                                this.handleOnChange(e, item.id);
                              }}
                              width={200}
                              colID="name"
                            />
                          </Grid>
                          <Grid item>
                            <p>{this.calculateSubtitle(item)}</p>
                          </Grid>
                        </Grid>
                      </Box>
                      <Grid item>{item.icon}</Grid>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Reports Section */}
        <Grid item xs={4}>
          <Card
            sx={{
              backgroundColor: "#f4f2f2",
              padding: 4,
            }}
          >
            <Typography
              variant="h5"
              style={{
                textAlign: "center",
                color: "#05699d",
                fontWeight: "600",
                letterSpacing: 2,
              }}
            >
              Reports
            </Typography>

            <Grid container spacing={2}>
              {this.state.reports.map((report, index) => (
                <Grid item xs={12} key={index}>
                  {/* <TransitionGroup> */}
                  <Card
                    //   className="zoom-card"
                    sx={{
                      height: "60px",
                      position: "relative",
                      cursor: "pointer",
                      transition:
                        "transform 0.3s ease-in-out, background-color 0.3s ease-in-out",
                      backgroundColor: report.color,
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                      e.currentTarget.style.backgroundColor = report.hcolor;
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.backgroundColor = report.color;
                    }}
                  >
                    {/* <CSSTransition */}
                    {/*    timeout={500}
                   classNames="fade" // Use your CSS transition classes here
              
               <div data-aos="zoom-in"> */}

                    {/* // </div> */}
                    {/* //   </CSSTransition> */}

                    <CardActions
                      onClick={() => {
                        this.handleNavigate(report.rout);
                      }}
                    >
                      <CardContent sx={{ padding: "4px" }}>
                        <Box display="flex" alignItems="center">
                          <Box mr={1}>{report.icon}</Box>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              color: "black",
                            }}
                          >
                            {report.title}
                          </Typography>
                        </Box>
                      </CardContent>
                    </CardActions>
                  </Card>
                  {/* </TransitionGroup> */}
                </Grid>
              ))}
            </Grid>
          </Card>
          <Grid item>
            <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
              {this.state.ARD}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
export default withRouter(
  connect(
    mapStatetoProps,
    mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps
  )(HOCVerifyIsUser(HOCReduxData(HoCtToastContainer(Dashboard2))))
);
